import type { IPublicCourseResponse } from "../../../app/features/courses/courses.types";
import CourseDetails from "./CourseDetails";
import CourseOverview from "./CourseOverview";
import CourseReviews from "./CourseReviews";
import PromotionList from "./PromotionList";
import TechServiceCard from "./TechServiceCard";

type Props = {
  course?: IPublicCourseResponse;
  isLoading?: boolean;
  onMoreButton?: () => void;
  moreButtonText?: string;
  moreButtonLoading?: boolean;
  moreButtonDisabled?: boolean;
};
export default function DetailsOverview({
  course,
  isLoading,
  onMoreButton,
  moreButtonText = "কোর্সটি দেখুন",
  moreButtonLoading,
  moreButtonDisabled,
}: Props) {
  return (
    <section className="mini-container container grid lg:grid-cols-3 gap-4 pt-8 pb-24">
      <div className="lg:col-span-2">
        <CourseOverview course={course} isLoading={isLoading} />
        <CourseDetails course={course} isLoading={isLoading} />
        <CourseReviews course={course} isLoading={isLoading} />
      </div>
      <div>
        <TechServiceCard
          course={course}
          isLoading={isLoading}
          moreButtonText={moreButtonText}
          onMoreButton={onMoreButton}
          moreButtonLoading={moreButtonLoading}
          moreButtonDisabled={moreButtonDisabled}
        />
        <PromotionList course={course} />
      </div>
    </section>
  );
}
